import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Container, Timestamp } from './AlertOrMacroMetadata.styles';

AlertOrMacroMetadata.propTypes = {
  resource: PropTypes.shape({
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    updatedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
  theme: PropTypes.string, // A value of `dark` will use `lightBlack`, instead of `darkGray1`, for the timestamp text.
};

export default function AlertOrMacroMetadata({ resource: { createdAt, updatedAt }, theme = 'light' }) {
  if (!(createdAt || updatedAt)) {
    return null;
  }

  return (
    <Container theme={theme}>
      {createdAt && (
        <div>
          <dt>Created</dt>
          <dd>{renderTimestamp(createdAt)}</dd>
        </div>
      )}
      {updatedAt && (
        <div>
          <dt>Updated</dt>
          <dd>{renderTimestamp(updatedAt)}</dd>
        </div>
      )}
    </Container>
  );

  function renderTimestamp(date) {
    const formattedDate = moment(date).format('MM/DD/YY');
    const formattedTime = moment(date).format('h:mm A');
    const localTz = moment.tz.guess();
    const formattedTz = moment().tz(localTz).format('z');

    return (
      <Timestamp>
        <span>{formattedDate}</span>
        <span>{`${formattedTime} ${formattedTz}`}</span>
      </Timestamp>
    );
  }
}
